import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';
import type {MyBrands, ProviderBrand} from '../../../types/ServiceProviderTypes';

export class GetMyBrandsUseCase {
  constructor (private repo: ServiceProviderRepository) {}

  async execute (): Promise<MyBrands | ProviderBrand[] | undefined> {
    return this.repo.getMyBrands();
  }
}
